var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"mx-auto"},[_c('p',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t("forbidden"))+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }